/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React, { ReactNode } from "react";
import DetailContainer from "../DetailContainer";
import VerticalSplitContainer from "../VerticalSplitContainer";

export interface VerticalSplitProps {
    right: () => ReactNode;
    left?: () => ReactNode;
}

export default function VerticalSplit(props: VerticalSplitProps) {
    return (
        <DetailContainer>
            <VerticalSplitContainer
                right={props.right()}
                left={props.left && props.left()}
            />
        </DetailContainer>
    );
}
